import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { useInteraction } from './useInteraction.js';
import { ZINDEX } from '../static/constants.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSkipLink = function useSkipLink() {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showChildren = _React$useState2[0],
    setShowChildren = _React$useState2[1];
  var ref = React.useRef(null);
  var focusableElementListeners = React.useMemo(function () {
    return {
      onFocus: function onFocus() {
        setShowChildren(true);
      },
      onBlur: function onBlur() {
        setShowChildren(false);
      }
    };
  }, [setShowChildren]);
  var containerListeners = React.useMemo(function () {
    return {
      onFocus: function onFocus() {
        var _ref$current;
        (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
      }
    };
  }, []);
  var _useInteraction = useInteraction(focusableElementListeners),
    interactionProps = _useInteraction.interactionProps;
  var _useInteraction2 = useInteraction(containerListeners),
    interactionPropsContainer = _useInteraction2.interactionProps;
  var containerProps = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, interactionPropsContainer), {}, {
      position: 'absolute',
      left: '0',
      zIndex: ZINDEX.SKIPLINK,
      top: showChildren ? '0' : '-100%',
      tabIndex: 0
    });
  }, [showChildren, interactionPropsContainer]);
  var focusableElementProps = React.useMemo(function () {
    return _objectSpread(_objectSpread({}, interactionProps), {}, {
      tabIndex: 0,
      ref: ref
    });
  }, [interactionProps]);
  return {
    focusableElementProps: focusableElementProps,
    containerProps: containerProps
  };
};

export { useSkipLink };
//# sourceMappingURL=useSkipLink.js.map
